/**
 * GMCC Specials → Celebrity（/app/gmcccelebrityrates）。
 * STATSIG.CELEBRITY.SEARCH → CELEBRITY_SEARCH
 *
 * 打开页面只是空表单，不算。
 * 点 Check rates 出结果才打 SEARCH。
 * 属性 purpose=Purchase|RateTermRefi|CashOutRefi
 *
 * 只覆盖 Celebrity。PPE Rates、Universe 不跨到这里。
 */
export enum GmccCelebrityEvent {
    /**
     * 询价出结果。
     * 属性 purpose=Purchase|RateTermRefi|CashOutRefi
     */
    SEARCH = 'CELEBRITY_SEARCH',
}
